module.exports = __webpack_public_path__ + "media/images/logo-38b8892132701c66b842b9f267c06849.svg";